import { ConditionalWrap } from '@magnetic/higher-order-components';
import { Tooltip } from '@magnetic/tooltip';
import React from 'react';
import { useNavContext } from '../nav-context.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const NavItemTooltip = /* @__PURE__ */ __name(({
  children,
  enabled = true,
  label
}) => {
  const { navZIndex } = useNavContext();
  return /* @__PURE__ */ React.createElement(ConditionalWrap, {
    condition: enabled,
    wrap: (node) => /* @__PURE__ */ React.createElement(Tooltip, {
      placement: "right",
      style: navZIndex ? { zIndex: navZIndex + 1 } : void 0,
      title: label
    }, node)
  }, children);
}, "NavItemTooltip");

export { NavItemTooltip };
//# sourceMappingURL=tooltip.js.map
